/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedShippingInfo_shipmentQuote = {
    readonly handlingTimeDisplay: string | null;
    readonly subTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly buyerServiceMethodDisplay: string | null;
    readonly serviceMethod: {
        readonly region: {
            readonly apiType: string | null;
            readonly code: string | null;
            readonly regionName: string | null;
        } | null;
    } | null;
    readonly showQuoteAsPending: boolean | null;
    readonly " $refType": "PdpSharedShippingInfo_shipmentQuote";
};
export type PdpSharedShippingInfo_shipmentQuote$data = PdpSharedShippingInfo_shipmentQuote;
export type PdpSharedShippingInfo_shipmentQuote$key = {
    readonly " $data"?: PdpSharedShippingInfo_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipmentQuote">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "displayShort",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "handlingTimeDisplay",
      "storageKey": "handlingTimeDisplay(displayShort:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "subTotalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerServiceMethodDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "apiType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
(node as any).hash = 'b405cfebc8f7da9c2ea38157a7580ae3';
export default node;
